import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const grades = {
    0: {val: 0, text: "Not this time"},
    1: {val: 1, text: "Not Engaging"},
    2: {val: 2, text: "OK"},
    3: {val: 3, text: "Engaging"},
    4: {val: 4, text: "Loved it"},
}

const PodReport = (props) => {

    const recordstoengagewith = props.attendees.filter(attendee => attendee.link).length - 1

    const [feedback, setFeedback] = useState(null);
    const [strikeShow, setStrikeShow] = useState(false);
    const [strikeReason, setStrikeReason] = useState("");
    const [strikeAuth0Sub, setStrikeAuth0Sub] = useState("");
    const [previousStrikes, setPreviousStrikes] = useState([])


    function getPreviousStrikes(auth0sub){
  
        apiGet(`intranetevents/getstrikeslastthreemonths/?auth0sub=${auth0sub}`).then(res => {
          res.json().then(data => {
            setPreviousStrikes(data)
          })
        })
    }

    function addStrike(){

  
  
          const body = {
            auth0sub: strikeAuth0Sub,
            eventid: props.eventid,
            reason: strikeReason
          }
  
          apiPut(`intranetevents/addlipodstrike`, body)
            .then(response => {setStrikeShow(false); setStrikeReason("")})
            .catch( err => console.log(err) )
    }

    if(feedback){
        return (
            <>
                <Button onClick={() => setFeedback(null)}>Back</Button>
                <h4>Feedback for {props.attendees.map(attendee => {
                    if(attendee.auth0sub === feedback){
                        return attendee.email
                    }
                })}</h4>

                <Table>
                    {props.records.filter(record => record.judgingauth0sub === feedback).map(record => {
                        return (
                            <>
                                <tr>
                                    <td><a target="_blank" href={props.attendees.filter(attendee => attendee.id === record.m2mid)[0].link}><Button>View Post</Button></a></td>
                                    <td>Liked: {record.liked ? "Yes" : "No"}</td>
                                    <td>Commented: {record.commented  ? "Yes" : "No"}</td>
                                    <td>Grade: {grades[record.grading].text}</td>
                                </tr>
                                <tr>
                                    <td colspan="4">Feedback: {record.feedback ? `"${record.feedback}"` : "None"}</td>
                                </tr>
                                <tr style={{backgroundColor: "grey"}}>
                                    <td colspan="4"></td>
                                </tr>
                            </>
                        )
                    })}
                </Table>

            </>
        )
    }else{
        return (
            <>
               <Container>
                    <Row>
                        <Col xs={6} lg = {3}>
                            Total Signed Up: {props.attendees.length}
                        </Col>
                        <Col xs={6} lg = {3}>
                            Total Links Added: {props.attendees.filter(attendee => attendee.link).length}/{props.attendees.length}
                        </Col>
                    </Row>
                    <Row>
                        <h4>Did not add link</h4>
                        <Table>
                            {props.attendees.map(attendee => {
                                if(!attendee.link){
                                    return (
                                        <tr>
                                        <td>{attendee.email}</td>
                                        <td><Button onClick={() => {setStrikeShow(true);  setStrikeAuth0Sub(attendee.auth0sub); getPreviousStrikes(attendee.auth0sub)}}>Add Strike</Button></td>
                                    </tr>
                                    )
                                }
                            })}
                        </Table>
                    </Row>
                    <Row>
                        <h4>Engagement Records</h4>
                        <Table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Engaged With</th>
                                    <th>Liked</th>
                                    <th>Commented</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.attendees.map(attendee => {
                                    if(attendee.link){
                                        return (
                                            <tr>
                                                <td>{attendee.email}</td>
                                                <td>{props.records.filter(record => record.judgingauth0sub === attendee.auth0sub).length}/{recordstoengagewith}</td>
                                                <td>{props.records.filter(record => record.judgingauth0sub === attendee.auth0sub && record.liked).length}/{recordstoengagewith}</td>
                                                <td>{props.records.filter(record => record.judgingauth0sub === attendee.auth0sub && record.commented).length}/{recordstoengagewith}</td>
                                                <td><Button onClick={() => setFeedback(attendee.auth0sub)}>View Feedback</Button></td>
                                                <td><Button onClick={() => {setStrikeShow(true); setStrikeAuth0Sub(attendee.auth0sub)}}>Add Strike</Button></td>
                                            </tr>
                                        )
                                    }
                                    
                                })}
                            </tbody>
                            <tr>
    
                            </tr>
                        </Table>
                    </Row>
                </Container>

                <Modal  show={strikeShow} onHide={() => {setStrikeShow(false); setStrikeReason("")}}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Strike</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Form.Group controlId="keywords.AddKeyword">
                        <Form.Label>What is the reason for this strike?</Form.Label>
                        <Form.Control onChange={(event) => setStrikeReason(event.target.value)} type="text" value={strikeReason} />
                    </Form.Group>
                    {previousStrikes.length > 1 && <p style={{color: "red"}}>Adding another strike will block this member from accessing the linkedIn Pods for 3 months</p>}
                    <h4>Previous Strikes</h4>
                    <Table>
                        <tbody>
                            {previousStrikes.map(strike => {
                                return (
                                    <tr>
                                        <td>{strike.date}</td>
                                        <td>{strike.reason}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={addStrike}>
                        Add Strike
                        </Button>
                        <Button variant="secondary" onClick={() => {setStrikeShow(false); setStrikeReason("")}}>
                        Cancel
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
    
}

export default PodReport;